import React, { Component, Fragment } from "react";
import { Accordion, Alert, Button, Card, Col, Modal, Row } from "react-bootstrap";
import AlertNoPermission from "../alerts/AlertNoPermission";
import CharacterDetails from "../pages/characters/CharacterDetails";
import LoadingProgressBar from "../spinners/LoadingProgressBar";

class CharacterDetailsAndVersionsModal extends Component {
    state = {
        loading: true,
        charDetails: null,
        noPermission: false,
        alert: null,
        activeEventKey: null,
    };

    getCharactersData = async () => {
        const { fetchURL, onShowAlert, t, uniqueCharID, userID } = this.props;
        const passData = { uniqueCharID: uniqueCharID, userID: userID };
        onShowAlert("");
        try {
            const response = await fetch(`${fetchURL}/character-all-versions`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        this.setState({ charDetails: fetchedData.charsList, loading: false });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
        }
    };

    componentDidMount() {
        this.getCharactersData();
    }

    render() {
        const { noPermission, alert, charDetails, loading, activeEventKey } = this.state;
        const { show, t, onClose, charName } = this.props;

        return (
            <Fragment>
                <Modal show={show} onHide={onClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("characters.characterDetailsModal.title")} {charName}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {noPermission ? (
                            <AlertNoPermission t={t} />
                        ) : alert ? (
                            <Alert variant={alert.variant}>{alert.message}</Alert>
                        ) : loading ? (
                            <LoadingProgressBar t={t} />
                        ) : (
                            <Row>
                                <Col xs={12}>
                                    <Accordion onSelect={(e) => this.setState({ activeEventKey: e })} id="charactersAccordion">
                                        {charDetails.map((e, i) => (
                                            <Card key={i + 1}>
                                                <Card.Header>
                                                    <p className="mb-0 float-left pt-2">
                                                        {t("characters.version")} {charDetails.length - i} {i === 0 ? t("characters.newest") : ""}
                                                    </p>
                                                    <Accordion.Toggle as={Button} variant="outline-primary" eventKey={i + 1} className="float-right">
                                                        {activeEventKey === i + 1 ? t("collapse") : t("expand")}
                                                    </Accordion.Toggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey={i + 1}>
                                                    <Card.Body>
                                                        <CharacterDetails details={e} t={t} />
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        ))}
                                    </Accordion>
                                </Col>
                            </Row>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" type="button" onClick={onClose}>
                            {t("close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

export default CharacterDetailsAndVersionsModal;
